import { Button, Form, InputGroup } from "react-bootstrap";
import { useState } from "react";
import { ChartOfAccountSelector } from "../utils/ExpensesSelector";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Popover } from "react-tiny-popover";
import AddAccounts from "../modals/AddAccounts";

function AccountPicker({
  onChange,
  value = {
    AccountID: "",
    Description: "",
    Type: "",
  },
  Type,
  label = "",
}) {
  const [showJournalPopover, setShowJournalPopover] = useState(false);
  const [showCreateNewAccountModal, setShowCreateNewAccountModal] = useState(
    false
  );

  const handleSelectedAccount = account => {
    onChange(account);
    setShowJournalPopover(false);
  };

  const handleAccountCreated = newAccount => {
    // Invalidate and refetch accounts query
    handleSelectedAccount(newAccount);
    setShowCreateNewAccountModal(false);
  };

  return (
    <>
      <div className="d-flex gap-3">
        <InputGroup hasValidation>
          <Form.Control
            placeholder="Select Account"
            value={`${value?.AccountID || "..."} / ${value?.Description ||
              "..."} / ${value?.Type || "..."}`}
            onChange={() => {}}
            readOnly
          />

          <Popover
            isOpen={showJournalPopover}
            onClickOutside={() => setShowJournalPopover(false)}
            content={() => (
              <ChartOfAccountSelector
                handleSelectedExpense={handleSelectedAccount}
                usage={"chart of accounts"}
                Type={Type}
              />
            )}
            position="bottom"
          >
            <InputGroup.Text onClick={() => setShowJournalPopover(true)}>
              <MagnifyIcon />
            </InputGroup.Text>
          </Popover>
        </InputGroup>
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => setShowCreateNewAccountModal(true)}
          className="text-nowrap"
        >
          + Create New
        </Button>
      </div>

      {showCreateNewAccountModal && (
        <AddAccounts
          show={showCreateNewAccountModal}
          onHide={() => setShowCreateNewAccountModal(false)}
          accountCreated={handleAccountCreated}
          disableSubAccountAddition={true}
        />
      )}
    </>
  );
}

export default AccountPicker;
